import React from 'react';
import { addDays, addHours, addMonths, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';

import DatePicker from '../../../Common/DatePicker';

export const StartDate: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { selectedForm, selectedForm2, oldContract, createNewContract, startDate, campaignOmaLummePrices, newContract } =
    ManageContractsApp.useState();

  const selectedNewContract = campaignOmaLummePrices.find((p) => parseInt(newContract.split('-')[0]) === p.contractTemplateNo);
  const selectedNewTariff = selectedNewContract?.tariffs.find((t) => parseInt(newContract.split('-')[1]) === t.tariffNo);

  const lastSpotPriceFix = oldContract?.deliveries
    ?.sort((a, b) => (isBefore(new Date(a.specialToDate || new Date()), new Date(b.specialToDate || new Date())) ? 1 : -1))
    .filter((d) => d.elementNo === 10 && !isSameDay(new Date(d.specialToDate || new Date()), new Date('2073-06-01')))[0];

  const lastSpotPriceFixEndDate = isAfter(new Date(lastSpotPriceFix?.specialToDate || new Date()), new Date())
    ? lastSpotPriceFix?.specialToDate
    : undefined;

  const tariffStartMaxTwoMonthsFromNow = selectedNewTariff && (selectedNewTariff.tariffNo === 214 || selectedNewTariff.tariffNo === 4);

  let minDate: Date | undefined = addDays(new Date(), selectedForm2 === 2 ? 18 : 5);
  let maxDate: Date | undefined = addMonths(new Date(), 6);

  const contractEndDate = lastSpotPriceFixEndDate
    ? new Date(lastSpotPriceFixEndDate)
    : oldContract && oldContract.endDate
      ? new Date(oldContract?.endDate)
      : oldContract && oldContract.activeDeliveries && oldContract.activeDeliveries[0].tariffToDate
        ? new Date(oldContract.activeDeliveries[0].tariffToDate)
        : undefined;
  const isTemporary =
    !isSameDay(startOfDay(contractEndDate || new Date()), startOfDay(new Date('2073-06-01T00:00:00'))) &&
    contractEndDate &&
    isBefore(contractEndDate, new Date('2073-06-01T00:00:00'));

  if (!(oldContract && createNewContract) && oldContract && contractEndDate && isTemporary) {
    minDate = contractEndDate;
  } else if (selectedForm === 4 && contractEndDate && !isSameDay(contractEndDate, new Date('2073-06-01'))) {
    minDate = contractEndDate;
  } else if (selectedNewTariff && selectedNewTariff.duration === 6) {
    maxDate = addMonths(new Date(), 3);
  } else if (tariffStartMaxTwoMonthsFromNow) {
    maxDate = addMonths(new Date(), 2);
  }

  return (
    <section className="manage-contracts-step stepNewStartDate">
      {selectedForm !== 4 && <h3>{t('manageContracts:manageContracts.NewDateTitle')}*</h3>}
      {selectedForm === 4 && <h3>{t('manageContracts:manageContracts.NewDateTitleForm4')}*</h3>}

      {selectedForm !== 4 && <p>{t('manageContracts:manageContracts.NewDateBody')}</p>}
      {selectedForm === 4 && <p>{t('manageContracts:manageContracts.NewDateBodyForm4')}</p>}

      <DatePicker
        type="single"
        day={{ date: startDate, setDate: () => dispatch(['changeStart', startDate]) }}
        limits={{ minDate, maxDate }}
        onDateChange={(startDate): void => {
          if (startDate) {
            startDate = addHours(startOfDay(startDate), 12);
          } else {
            startDate = new Date();
          }
          dispatch(['changeStart', startDate]);
          if (selectedForm === 4) {
            dispatch(['changeEnd', startDate]);
          }
          if (isAfter(startDate, addMonths(new Date(), 6))) {
            dispatch(['changeStart', addMonths(new Date(), 6)]);
          }
          if (selectedNewTariff && selectedNewTariff.duration === 6 && isAfter(startDate, addMonths(new Date(), 3))) {
            dispatch(['changeStart', addMonths(new Date(), 3)]);
          }
          if (tariffStartMaxTwoMonthsFromNow && isAfter(startDate, addMonths(new Date(), 2))) {
            dispatch(['changeStart', addMonths(new Date(), 2)]);
          }
        }}
      />
    </section>
  );
};

export default StartDate;
